import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  drawerRightMenu: false,
  requestId: {},
  fullScreenType: false
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  OPEN_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 1)
    state.sidebar.opened = true
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  TOGGLE_DRAWERRIGHTMENU: (state, type) => {
    state.drawerRightMenu = type
  },
  SAVE_REQUESTID: (state, requestMessage) => {
    if (state.requestId[requestMessage.route]) {
      if (state.requestId[requestMessage.route].length >= 10) {
        state.requestId[requestMessage.route].pop()
      }
      state.requestId[requestMessage.route].unshift(requestMessage.requestId)
    } else {
      state.requestId[requestMessage.route] = [requestMessage.requestId]
    }
  },
  TOGGLE_FULLSCREENTYPE: (state, type) => {
    state.fullScreenType = type
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  openSideBar({ commit }, { withoutAnimation }) {
    commit('OPEN_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  toggleDrawerRightMenu({ commit }, type) {
    commit('TOGGLE_DRAWERRIGHTMENU', type)
  },
  saveRequestId({ commit }, requestMessage) {
    commit('SAVE_REQUESTID', requestMessage)
  },
  toggleFullScreenType({ commit }, type) {
    commit('TOGGLE_FULLSCREENTYPE', type)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
